<script setup lang="ts">
import { useSidebarPrivileges } from '@hooks/sidebar/sidebar-privileges.hook'

import UserAvailability from '@Molecules/Auth/UserAvailability.vue'
import UserMenu from '@Molecules/Auth/UserMenu.vue'

defineOptions({
  name: 'UserPanel',
})

const { canManageAvailability } = useSidebarPrivileges()
</script>

<template>
  <div :class="['user-panel', { availability: canManageAvailability }]">
    <UserAvailability v-if="canManageAvailability" />
    <UserMenu />
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/Auth/UserPanel.scss" />
